<template>
    <div>
        <div class="main-wrapper">
            <!--begin::sidebar-->
            <sidebar-component classMenu="Driver"></sidebar-component>
            <!--end::sidebar-->

            <div class="page-wrapper">
                <!--begin::navbar-->
                <navbar-component></navbar-component>
                <!--end::navbar-->

                <!--begin::content-->
                <div class="page-content">
                    <div class="
                d-flex
                justify-content-between
                align-items-center
                flex-wrap
                grid-margin
              ">
                        <div>
                            <h4 class="mb-12 mb-md-0"></h4>
                        </div>

                        <div class="col-lg-12 col-xl-12 stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <h4 style="margin-right: 5px" class="float-start">Driver Approval</h4>
                                    <button v-if="permision_role.method_custom2"
                                        class="btn btn-primary float-end btn-xs" style="margin-right: 5px"
                                        @click.prevent="createData()">
                                        <i class="link-icon" data-feather="plus"></i>
                                        New Approval
                                    </button>

                                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="downloadData()">
                                        <i class="link-icon" data-feather="download"></i>
                                        {{ $t("downloadData") }} .xlsx
                                    </button>
                                </div>

                                <div class="card-body">
                                    <vue-good-table title="list-user" mode="remote" @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords"
                                        :line-numbers="true" :isLoading.sync="isLoading" :pagination-options="{
                                        enabled: true,
                                    }" :rows="rows" :columns="columns">
                                        <template slot="table-row" slot-scope="props">

                                            <span v-if="props.column.field == 'actions'">
                                                <a href="#" v-if="permision_role.method_custom4" title="Detail"
                                                    @click.prevent="
                                        detailData(props.index, props.row)
                                        ">
                                                    <i class="mdi mdi-eye" style="font-size:16px"></i>

                                                </a>

                                                <a href="#"
                                                    v-if="permision_role.method_custom4 && props.row.status == 'APPROVED'"
                                                    title="Detail" @click.prevent="
                                        detailToDriver(props.index, props.row)
                                        ">
                                                    <i class="mdi mdi-chevron-double-right" style="font-size:16px"></i>

                                                </a>


                                                <a href="#"
                                                    v-if="props.row.status == 'REQUESTED' && permision_role.method_custom1"
                                                    title="ApproveData" @click.prevent="
                                        approveData(props.index, props.row)
                                        ">
                                                    <i class="mdi mdi-check" style="font-size:16px"></i>
                                                </a>

                                                <a href="#"
                                                    v-if="props.row.status == 'REQUESTED' && permision_role.method_custom1"
                                                    title="RejectData" @click.prevent="
                                        rejectData(props.index, props.row)
                                        ">
                                                    <i class="mdi mdi-close" style="font-size:16px"></i>
                                                </a>

                                                <!-- <a href="#" v-if="permision_role.method_custom2" title="Send To Blujay"
                                                    @click.prevent="
                                        sendToBlujay(props.index, props.row)
                                        ">
                                                    <i class="mdi mdi-send" style="font-size:16px"></i>
                                                </a> -->

                                            </span>

                                            <span v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </span>
                                        </template>
                                    </vue-good-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::content-->

                <!--begin::footer-->
                <footer-component></footer-component>

                <modalDownloadDepositDriver>

                </modalDownloadDepositDriver>

                <modalDownloadDepositDriver :showModal="showModalNow" @closeModal="closeMyModal">
                </modalDownloadDepositDriver>

                <!--end::footer-->
            </div>
        </div>
    </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalDownloadDepositDriver from "@/components/modal/modalDownloadDepositDriver"

export default {
    name: "DriverApprovalIndex",
    components: {
        "sidebar-component": sidebarComponent,
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        modalDownloadDepositDriver
    },
    data() {
        return {
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            showModalNow: false,
            errors: [],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            detailDivisi: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            columns: [
                {
                    label: "Status",
                    field: "status",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By Status", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "Driver Name",
                    field: "driver_name",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By Driver Id", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: "KTP",
                    field: "driver_ktp",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: "SIM",
                    field: "driver_sim",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: "Type",
                    field: "driver_type",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: "Category",
                    field: "driver_category",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: "Approve at",
                    field: "approved_at",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: "Reject at",
                    field: "rejected_at",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },




                {
                    label: "Action",
                    field: "actions",
                    sortable: false,
                },
            ],
            rows: [],
        };
    },
    watch: {},
    methods: {
        sendToBlujay(index, row) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataSend"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    // this.loadingSubmiting();
                    this.fade(true);

                    const baseURI = this.$settings.endPointCt + "driver-nmk/send-to-nintex/" + row.master_driver_id;
                    this.$http
                        .post(baseURI,)
                        .then((response) => {
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                                this.isloading = false;
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                            } else {
                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 500) {
                                        this.$router.push("/server-error");
                                    } else if (error.response.status === 401) {
                                        this.$router.push("/authorized-error");
                                    } else {
                                        this.$router.push("/page-not-found");
                                    }
                                }
                            }
                        });
                }
            });
        },


        approveData(index, row) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: "Are you sure to approval?",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    // this.loadingSubmiting();
                    this.fade(true);

                    const baseURI = this.$settings.endPointCt + "driver-approval/approve/" + row.driver_approval_id;
                    this.$http
                        .post(baseURI,)
                        .then((response) => {
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                                // window.location.href = `/driver/add?driver_name=${row.driver_name}&id_card_number=${row.driver_ktp}&sim_no=${row.driver_sim}&birth_date=${row.blacklist.birth_date}&birth_place=${row.blacklist.birth_place}&status=200&msg=Successfully`;


                                this.isloading = false;
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                            } else {
                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 500) {
                                        this.$router.push("/server-error");
                                    } else if (error.response.status === 401) {
                                        this.$router.push("/authorized-error");
                                    } else {
                                        this.$router.push("/page-not-found");
                                    }
                                }
                            }
                        });
                }
            });
        },


        rejectData(index, row) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: "Are you sure to reject?",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    // this.loadingSubmiting();
                    this.fade(true);

                    const baseURI = this.$settings.endPointCt + "driver-approval/reject/" + row.driver_approval_id;
                    this.$http
                        .post(baseURI,)
                        .then((response) => {
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                                this.isloading = false;
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.isLoading = false;
                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));
                            } else {
                                if (error.response) {
                                    if (error.response.status === 422) {
                                        this.errors = error.response.data.errors;
                                        this.resultError(error.response.data.errors);
                                    } else if (error.response.status === 500) {
                                        this.$router.push("/server-error");
                                    } else if (error.response.status === 401) {
                                        this.$router.push("/authorized-error");
                                    } else {
                                        this.$router.push("/page-not-found");
                                    }
                                }
                            }
                        });
                }
            });
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'DriverApprovalController') {
                    rolePermision = permision;
                    // console.log(permision);
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;

        },

        closeMyModal() {
            this.showModalNow = false;
            //this.loadData(this.vehicle_no);
        },

        downloadReportDeposit() {
            this.showModalNow = true;
        },

        downloadData() {
            const baseURI = this.$settings.endPointCt + "/driver-approval";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";

            //var columnFilters = this.serverParams.columnFilters;

            return this.$http
                .get(
                    baseURI +
                    // `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&driver_status=${this.serverParams.columnFilters.driver_status}&id_card_number=${this.serverParams.columnFilters.id_card_number}&nickname=${this.serverParams.columnFilters.nickname}&sim1_type=${this.serverParams.columnFilters.sim1_type}&sim1_expire_date=${this.serverParams.columnFilters.sim1_expire_date}&download=download`,
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&status=${this.serverParams.columnFilters.status}`,
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {

                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
        },

        // downloadData() {
        //   this.fade(true);
        //   var baseURI = this.$settings.endPoint + "/user/download";
        //   var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        //   var columnFilters = this.serverParams.columnFilters;
        //   var role = columnFilters["role.name"];
        //   var company_code = columnFilters["company_detail.code"];

        //   var sendData = {
        //     username: this.serverParams.columnFilters.username,
        //     name: this.serverParams.columnFilters.name,
        //     email: this.serverParams.columnFilters.email,
        //     level: this.serverParams.columnFilters.level,
        //     status: this.serverParams.columnFilters.status,
        //     role:role,
        //     company_code: company_code,
        //     file_name: "download_" + CurrentDate + ".xlsx",
        //   };
        //   this.$http({
        //     url: baseURI,
        //     method: "GET",
        //     data: sendData,
        //     responseType: "blob",
        //   })
        //     .then((response) => {
        //       this.errors = [];
        //       var filename = sendData.file_name;

        //       var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        //       var fileLink = document.createElement("a");

        //       fileLink.href = fileURL;
        //       fileLink.setAttribute("download", filename);
        //       document.body.appendChild(fileLink);
        //       fileLink.click();
        //       this.fade(false);
        //     })
        //     .catch((error) => {
        //       if (error.response) {
        //         if (error.response.status === 422) {
        //           this.errors = { message: ["File Not Found"] };
        //           this.error("File Not Found");
        //         } else if (error.response.status === 500) {
        //           this.$router.push("/server-error");
        //         } else {
        //           this.$router.push("/page-not-found");
        //         }
        //       }
        //     });
        // },
        createData() {
            window.location.href = "./driver-approval/check";
        },

        uploadData() {
            window.location.href = "/driver/upload";
        },

        editData(index, row) {
            var params = this.$onRandom(row.master_driver_id);
            window.location.href = "/driver/edit/" + params;
        },

        detailData(index, row) {
            var params = this.$onRandom(row.driver_blacklist_id);
            window.location.href = "/driver/driver-blacklist/detail/" + params + "?from=approval";
        },

        detailToDriver(index, row) {
            if (row.master_driver_id == 0 || row.master_driver_id == null) {
                window.location.href = `/driver/add?driver_name=${row.driver_name}&id_card_number=${row.driver_ktp}&sim_no=${row.driver_sim}&birth_date=${row.blacklist.birth_date}&birth_place=${row.blacklist.birth_place}&approved_at=${row.approved_at}&driver_approval_id=${row.driver_approval_id}&status=200&msg=Successfully`;
            } else {
                var params = this.$onRandom(row.master_driver_id);
                window.location.href = `/driver/edit/${params}?driver_name=${row.driver_name}&id_card_number=${row.driver_ktp}&sim_no=${row.driver_sim}&birth_date=${row.blacklist.birth_date}&birth_place=${row.blacklist.birth_place}&approved_at=${row.approved_at}&driver_approval_id=${row.driver_approval_id}&status=200&msg=Successfully`;
            }
        },

        deleteData(index, row, status) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    var formData = {
                        status: status,
                    };
                    const baseURI =
                        this.$settings.endPointCt + "master-driver/delete/" + row.master_driver_id;
                    this.$http
                        .delete(baseURI, formData)
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.loading();
                            if (error.response) {
                                if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                } else if (error.response.status === 500) {
                                    this.$router.push("/server-error");
                                } else {
                                    this.$router.push("/page-not-found");
                                }
                            }
                        });
                }
            });
        },

        // load items is what brings back the rows from server
        loadItems() {
            const baseURI = this.$settings.endPointCt + "driver-approval";

            //var columnFilters = this.serverParams.columnFilters;


            return this.$http
                .get(
                    baseURI +
                    //  `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&driver_id=${this.serverParams.columnFilters.driver_id}&driver_name=${this.serverParams.columnFilters.driver_name}&driver_status=${this.serverParams.columnFilters.driver_status}&id_card_number=${this.serverParams.columnFilters.id_card_number}&nickname=${this.serverParams.columnFilters.nickname}&sim1_type=${this.serverParams.columnFilters.sim1_type}&sim1_expire_date=${this.serverParams.columnFilters.sim1_expire_date}&branch_name=${this.serverParams.columnFilters.branch_name}&project_name=${this.serverParams.columnFilters.project_name}`,
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&status=${this.serverParams.columnFilters.status}&driver_category=${this.serverParams.columnFilters.driver_category}&driver_ktp=${this.serverParams.columnFilters.driver_ktp}&driver_name=${this.serverParams.columnFilters.driver_name}&driver_sim=${this.serverParams.columnFilters.driver_sim}&driver_type=${this.serverParams.columnFilters.driver_type}`,
                )
                .then((response) => {

                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                });
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },

        onColumnFilter(params) {
            params.page = 1;
            this.updateParams(params);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },

        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },


        logout() {
            this.$logoutUser();
            this.$router.push("/");
        },
    },
    events: {},
    created: function () { },
    mounted() {
        this.fetchIt();
        this.loading();
    },
};
</script>
<style scoped></style>